import React from "react";
import { Typography, Box } from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import CampaignIcon from "@mui/icons-material/Campaign";
import PostAddIcon from "@mui/icons-material/PostAdd";
import ListAltIcon from "@mui/icons-material/ListAlt";
import { Link } from "react-router-dom";
import { useState } from "react";
import { Menu, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

export default function P2PNavbar() {
  const theme = localStorage.getItem("theme");
  const { btncolor } = useSelector((state) => state);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const navigate = useNavigate();

  const handleMouseEnter = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMouseLeave = () => {
    setAnchorEl(null);
  };

  const navItems = [
    { label: "Dashboard", icon: <DashboardIcon sx={{ fontSize: 18 }} />, to: "/p2p/dashboard" },
    { label: "My Orders", icon: <AssignmentIcon sx={{ fontSize: 18 }} />, to: "/p2p/my-orders" },
    { label: "My Profile", icon: <AccountCircleIcon sx={{ fontSize: 18 }} />, to: "/p2p/my-profile" },
  ];

  return (
    <Box sx={navbarWrap}>
      <Box sx={navbarInner}>
        {navItems.map((item) => (
          <Link
            key={item.label}
            to={item.to}
            className="no-underline"
            style={{ textDecoration: "none" }}
          >
            <Box sx={navItem}>
              <Box sx={{ color: "var(--text-color)", opacity: 0.7, display: "flex" }}>
                {item.icon}
              </Box>
              <Typography sx={navItemLabel}>{item.label}</Typography>
            </Box>
          </Link>
        ))}

        {/* Ad Center with dropdown */}
        <Box onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
          <Box sx={navItem}>
            <Box sx={{ color: "var(--text-color)", opacity: 0.7, display: "flex" }}>
              <CampaignIcon sx={{ fontSize: 18 }} />
            </Box>
            <Typography sx={navItemLabel}>Ad Center</Typography>
          </Box>
          <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={handleMouseLeave}
            MenuListProps={{ onMouseLeave: handleMouseLeave }}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
            transformOrigin={{ vertical: "top", horizontal: "center" }}
            PaperProps={{
              sx: {
                backgroundColor: "var(--popupbody-color)",
                border: "1px solid rgba(125,125,125,0.15)",
                borderRadius: "10px",
                boxShadow: "0 8px 24px rgba(0,0,0,0.18)",
                mt: 0.5,
              },
            }}
          >
            <MenuItem
              onClick={() => navigate("/p2p/post-ad")}
              sx={dropdownItem}
            >
              <PostAddIcon sx={{ fontSize: 16, mr: 1, opacity: 0.7 }} />
              <Typography sx={{ fontSize: "0.85rem", color: "var(--text-color)" }}>
                Post New Ad
              </Typography>
            </MenuItem>
            <MenuItem
              onClick={() => navigate("/p2p/my-ads")}
              sx={dropdownItem}
            >
              <ListAltIcon sx={{ fontSize: 16, mr: 1, opacity: 0.7 }} />
              <Typography sx={{ fontSize: "0.85rem", color: "var(--text-color)" }}>
                My Ads
              </Typography>
            </MenuItem>
          </Menu>
        </Box>
      </Box>
    </Box>
  );
}

// ── Styles ────────────────────────────────────────────────────────────────────

const navbarWrap = {
  borderBottom: "1px solid rgba(125,125,125,0.15)",
  backgroundColor: "var(--body-color-less2)",
  px: { xs: 1, md: 2 },
};

const navbarInner = {
  display: "flex",
  alignItems: "center",
  gap: 0.5,
  minHeight: 56,
  overflowX: "auto",
  "&::-webkit-scrollbar": { display: "none" },
};

const navItem = {
  display: "flex",
  alignItems: "center",
  gap: 0.75,
  px: 2,
  py: 1.75,
  cursor: "pointer",
  borderRadius: "6px",
  transition: "background-color 0.15s ease",
  "&:hover": {
    backgroundColor: "rgba(125,125,125,0.08)",
    "& .MuiTypography-root": { opacity: 1 },
    "& .MuiBox-root": { opacity: 1 },
  },
};

const navItemLabel = {
  fontSize: "0.88rem",
  fontWeight: 600,
  color: "var(--text-color)",
  opacity: 0.65,
  whiteSpace: "nowrap",
  letterSpacing: "0.01em",
};

const dropdownItem = {
  px: 1.5,
  py: 1,
  "&:hover": { backgroundColor: "rgba(125,125,125,0.08)" },
};
